export const evaluateItinerary = async ({ categoryId, rating, comment }) => {
	return await post('evaluateItinerary', { categoryId, rating, comment })
}

export const evaluateItinerarySecondQuestion = async ({ proxyId, rating }) => {
	return await post('evaluateItinerarySecondQuestion', { proxyId, rating })
}
